import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { AProvider } from "src/framework/providers/AProvider";
import { ITermoAceite, ResponseTermoAceiteFinanceiras, ResponseTermoAceitePedido } from "./types";

class TermoDeAceiteProvider extends AProvider {
    constructor() {
        super("/cadastros/termos_aceite_pedidos");
    }

    async fetchTermosAceitePedido(pedido: string): Promise<IDataResponse<ResponseTermoAceitePedido | null>> {
        const request: IDataRequest = {
            url: `${this.path}/pedido/${pedido}`
        }

        const response: IDataResponse = await api.post(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response
        }

        return {
            data: null,
            message: response.message,
            statusCode: response.statusCode
        };
    }

    async fetchTermosAceiteFinanceiras(pedido: string): Promise<IDataResponse<ResponseTermoAceiteFinanceiras | null>> {
        const request: IDataRequest = {
            url: `${this.path}/financeiras/${pedido}`,
            data: {
                tipo: "financeiras"
            }
        }

        const response: IDataResponse = await api.post(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response
        }

        return {
            data: null,
            message: response.message,
            statusCode: response.statusCode
        };
    }
}

const termoDeAceiteProvider = new TermoDeAceiteProvider();


export { termoDeAceiteProvider, TermoDeAceiteProvider }